import React from 'react';
import { CountContainer, CourseTitle } from '../style';
import useLocalization from '../../../../../../hooks/useLocalization';
import { Input } from '../../../editor/MediaInputGroup/styles';
export var CountBlock = function (_a) {
    var count = _a.count, onCountChange = _a.onCountChange, types = _a.types;
    var t = useLocalization().t;
    var handleCountChange = function (e) {
        var value = e.target.value;
        var number = parseInt(value, 10);
        if ((value === '' || (number >= 1 && number <= 20)) && /^[0-9]*$/.test(value)) {
            onCountChange(value);
        }
    };
    if (!types || types.length === 0)
        return null;
    return (React.createElement(CountContainer, { direction: 'row', gx: 8, align: 'center' },
        React.createElement(Input, { value: count, onChange: handleCountChange }),
        React.createElement(CourseTitle, null, t('lms.max_block_count'))));
};
//# sourceMappingURL=CountBlock.js.mapimport React from 'react';
import { CountContainer, CourseTitle } from '../style';
import useLocalization from '../../../../../../hooks/useLocalization';
import { Input } from '../../../editor/MediaInputGroup/styles';
export var CountBlock = function (_a) {
    var count = _a.count, onCountChange = _a.onCountChange, types = _a.types;
    var t = useLocalization().t;
    var handleCountChange = function (e) {
        var value = e.target.value;
        var number = parseInt(value, 10);
        if ((value === '' || (number >= 1 && number <= 20)) && /^[0-9]*$/.test(value)) {
            onCountChange(value);
        }
    };
    if (!types || types.length === 0)
        return null;
    return (React.createElement(CountContainer, { direction: 'row', gx: 8, align: 'center' },
        React.createElement(Input, { value: count, onChange: handleCountChange }),
        React.createElement(CourseTitle, null, t('lms.max_block_count'))));
};
//# sourceMappingURL=CountBlock.js.map